import {
  GET_ORPHANS_LIST_LOADING,
  GET_ORPHANS_LIST_SUCCESS,
  GET_ORPHANS_LIST_FAILURE,
} from "redux/types";

const initialState = {
  orphanListLoading: false,
  orphanList: null,
  errors: null,
};

export const getOrphanListReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_ORPHANS_LIST_LOADING:
      return { ...state, orphanListLoading: action.payload };
    case GET_ORPHANS_LIST_SUCCESS:
      return { ...state, orphanList: action.payload };
    case GET_ORPHANS_LIST_FAILURE:
      return { ...state, errors: action.payload };
    default:
      return state;
  }
};
